import FondoDashboard from "../../images/bg-dashboard.jpg";
import { useRouterStore } from "../../../libs/stores";
import {
  ClientComponent,
  ClientAdministratorComponent,
  AdministratorComponent,
  ProcessOneComponent,
  ProcessTwoComponent,
  ProcessThreeComponent,
} from "./components";
import { useWidth } from "../../../libs/hooks";

const options = [
  { value: "hoy", label: "Hoy" },
  { value: "semana", label: "Esta Semana" },
  { value: "mes", label: "Este Mes" },
  { value: "3meses", label: "Últimos 3 Meses" },
];

const Dashboard = () => {
  const width = useWidth();
  const isMobile = width === "xs";
  const isTablet = width === "sm";

  const typeDashboardCode = useRouterStore((state) => state.typeDashboardCode);

  return (
    <div
      style={{
        position: "relative",
        height: "100%",
        width: "100%",
        maxWidth: "100%",
        overflowX: "hidden",
        overflowY: "auto",
        backgroundImage: `url(${FondoDashboard})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundAttachment: "fixed",
        backgroundSize: "cover",
        display: "flex",
        justifyContent: "center",
        alignContent: "flex-start",
        alignItems: "flex-start",
        paddingTop: isMobile || isTablet ? "16px" : "24px",
        paddingBottom: "24px",
      }}
    >
      {typeDashboardCode === "DASHBOARD_CLIENT" ? (
        <ClientComponent options={options} />
      ) : null}
      {typeDashboardCode === "DASHBOARD_CLIENT_ADMINISTRATOR" ? (
        <ClientAdministratorComponent options={options} />
      ) : null}
      {typeDashboardCode === "DASHBOARD_ADMINISTRATOR" ? (
        <AdministratorComponent options={options} />
      ) : null}
      {typeDashboardCode === "DASHBOARD_PROCESS_ONE" ? (
        <ProcessOneComponent options={options} />
      ) : null}
      {typeDashboardCode === "DASHBOARD_PROCESS_TWO" ? (
        <ProcessTwoComponent options={options} />
      ) : null}
      {typeDashboardCode === "DASHBOARD_PROCESS_THREE" ? (
        <ProcessThreeComponent options={options} />
      ) : null}
    </div>
  );
};

export default Dashboard;
